import { run } from './projection';
import { randn } from '../utils/random';
export function monte(s, n = 500) {
  const results = [];
  for (let i = 0; i < n; i++) {
    const sim = run({
      ...s,
      ret: Math.max(0.01, s.ret + randn() * 0.03),
      salGr: Math.max(0.005, s.salGr + randn() * 0.015),
      hApp: Math.max(0.005, s.hApp + randn() * 0.01),
    });
    results.push(sim);
  }
  const maxLen = results[0]?.length || 0;
  const percentiles = [];
  for (let i = 0; i < maxLen; i++) {
    const nws = results.map(r => r[i]?.nw || 0).sort((a, b) => a - b);
    percentiles.push({
      a: results[0][i].a,
      p10: nws[Math.floor(n * 0.1)],
      p25: nws[Math.floor(n * 0.25)],
      p50: nws[Math.floor(n * 0.5)],
      p75: nws[Math.floor(n * 0.75)],
      p90: nws[Math.floor(n * 0.9)],
    });
  }
  return percentiles;
}
